/* =============================================================================
   mkv4-fit-help.js — PATCH 38 (2026-05-30)
   -----------------------------------------------------------------------------
   Injecte une phrase d'aide juste apres le selecteur vehicule (matrikar-vehicle-fit).
   Auto-scope : si #mkvfit-wrap n'existe pas (produits no-vehicle-fit : organizer,
   petshield, backseat), le script ne fait rien.
   N'altere PAS la logique du snippet matrikar-vehicle-fit (insertion APRES).
   Idempotent : .mkv4-fit-help check evite la double insertion.
   ============================================================================= */
(function () {
  function inject() {
    var wrap = document.getElementById('mkvfit-wrap');
    if (!wrap) return;
    if (document.querySelector('.mkv4-fit-help')) return;
    var p = document.createElement('p');
    p.className = 'mkv4-fit-help';
    p.innerHTML =
      "Can't find your model or have a question? " +
      '<a href="/pages/contact-us">Contact us</a>.';
    wrap.insertAdjacentElement('afterend', p);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inject);
  } else {
    inject();
  }
  /* Filet de securite : si matrikar-vehicle-fit re-rend son contenu apres
     un changement d'etat (selection / change), on tente une re-injection. */
  document.addEventListener('matrikar:vehicleSelected', inject);
  document.addEventListener('matrikar:vehicleChanged', inject);
})();
